export default "__VITE_ASSET__CnmSI4F$__"